<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Notas de credito</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div></div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Búsqueda de notas
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label for="fci">Fecha de inicio</label>
                <b-input-group size="sm" class="mb-2" id="fci" lab>
                  <b-form-datepicker
                      name="nombre"
                      placeholder="Fecha de Inicio"
                      v-model="$v.filtro.fechaInicio.$model"
                      :state="validateState('fechaInicio')"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group align="left">
                <label for="fcf">Fecha de fin</label>
                <b-input-group size="sm" class="mb-2" id="fcf" lab>
                  <b-form-datepicker
                      name="nombre"
                      placeholder="Fecha de Fin"
                      :min="filtro.fechaInicio"
                      :max="new Date()"
                      v-model="$v.filtro.fechaFin.$model"
                      :state="validateState('fechaFin')"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col></b-col>
            <b-col class="text-right">
              <b-button
                  variant="outline-primary"
                  :disabled="loader"
                  @click="obtenerDatos()"
              >
                <span v-if="!loader">Buscar</span>
                <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
            <template v-slot:cell(monto)="row">
              {{row.item.monto | moneda}}
            </template>
            <template v-slot:cell(fecha)="row">
              {{row.item.fecha | formatoFechaCorta}}
            </template>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    title="Realizar Corte"
                    size="sm"
                    v-b-tooltip.hover.top="'Imprimir Factura'"
                    :disabled="row.item.loaderImpresion"
                    @click="imprimirFactura(row.item)"
                    variant="outline-primary"
                >
                  <font-awesome-icon  v-if="row.item.loaderImpresion === false" icon="print" />
                  <b-spinner v-else small></b-spinner>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>


      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header";
import * as JSZip from "jszip";
import { saveAs } from 'file-saver'
import {required} from "vuelidate/lib/validators";
export default {
  name: "FacturasCorteCaja",
  components: {Header},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      fields: [
        {key: "idFactura", label: "ID", sortable: true},
        {key: "paciente", label: "Paciente", sortable: true},
        {key: "clinica", label: "Clínica", sortable: true},
        {key: "monto", label: "Monto Facturado", sortable: true},
        {key: "recibo", label: "Recibo", sortable: true},
        {key: "fecha", label: "Fecha de emision", sortable: true},
        {key: "uuid", label: "UUID", sortable: true},
        "Acciones",
      ],
      registrosPorPagina: 15,
      paginaActual: 0,
      loaderAcciones: false,
      loader: false,
      filtro: {
        fechaInicio: null,
        fechaFin: null,
      },
    }
  },
  validations: {
    filtro: {
      fechaInicio: {required},
      fechaFin: {required},
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    obtenerDatos() {
      this.$v.filtro.$touch();
      if (!this.$v.filtro.$invalid) {
        this.loader = true;

        this.datosTabla = [];
        const envio = {
          fechaInicio: this.$moment(this.filtro.fechaInicio)
              .utc()
              .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
          fechaFin: this.$moment(this.filtro.fechaFin)
              .add(1, "days")
              .utc()
              .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
          horas: this.$horas(),
        };
        this.$http
            .post(this.$api + "fiscales/notas",envio)
            .then((response) => {
              if (response.data.data) {
                response.data.data.map(value => {
                  value.loaderImpresion = false;
                  this.datosTabla.push(value)
                })
              }
            }).finally(() => {
          this.loader = false;
        });
      }
    },
    imprimirFactura(item) {
      item.loaderImpresion = true;
      this.$http.get(this.$api + 'reportes/factura?idFactura=' + item.idFactura).then(respuesta => {
        if (respuesta.data.data) {
          const datos = respuesta.data.data
          this.descargarFactura(datos)
        }
      }).finally(() => {
        item.loaderImpresion = false
      })
    },
    descargarFactura(datos){
      const pdf =datos.pdf;
      const xml =datos.xml;
      const folio =datos.uid;
      const zip = new JSZip();
      zip.file(folio+".xml", xml, {base64: false});
      zip.file(folio+".pdf", pdf, {base64: true});
      zip.generateAsync({type:"blob"})
          .then(function(content) {
            saveAs(content, folio+".zip");
          });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },

  }
}
</script>

<style scoped>

</style>
